import { FreshnessMonitor } from "@/features/oversight/monitoring";

export default function MonitoringFreshnessPage() {
  return <FreshnessMonitor />;
}
